// extracted by mini-css-extract-plugin
export default {"defaultIcon":"defaultIcon____B97m"};